import _styled from '@emotion/styled/base';
import Box from '@mui/material/Box';
import Popover from '@mui/material/Popover';
import InputField from '../InputField/InputField.js';
import isStyledPropsValid from '../utils/isStyledPropsValid.js';
const StyledPopover = /*#__PURE__*/_styled(Popover, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1v59eef8"
})(_ref => {
  return {
    '& .MuiPaper-root': {
      width: '120px'
    }
  };
}, "");
const StyledInputArea = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1v59eef7"
})(_ref2 => {
  return {
    padding: '5px'
  };
}, "");
const StyledInputField = /*#__PURE__*/_styled(InputField, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1v59eef6"
})(_ref3 => {
  return {
    '& .MuiInputBase-root': {
      height: '20px',
      '& .MuiInputBase-input': {
        fontSize: '12px'
      }
    }
  };
}, "");
const StyledDeleteArea = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1v59eef5"
})(_ref4 => {
  let {
    theme
  } = _ref4;
  return {
    padding: '7px 5px',
    color: theme.customColors.grey[700],
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: 700,
    '& i': {
      color: theme.customColors.grey[500],
      marginRight: '5px'
    }
  };
}, "");
const StyledLine = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1v59eef4"
})(_ref5 => {
  let {
    theme
  } = _ref5;
  return {
    height: '1px',
    backgroundColor: theme.customColors.grey[700],
    marginBottom: '3px'
  };
}, "");
const StyledPickColorArea = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1v59eef3"
})(_ref6 => {
  return {};
}, "");
const StyledPickColorAreaTitle = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1v59eef2"
})(_ref7 => {
  let {
    theme
  } = _ref7;
  return {
    color: theme.customColors.grey[500],
    fontSize: '12px',
    padding: '5px',
    fontWeight: 700
  };
}, "");
const StyledPalette = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1v59eef1"
})(_ref8 => {
  return {
    paddingLeft: '7px',
    paddingRight: '7px',
    paddingBottom: '7px'
  };
}, "");
const StyledSingleColor = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "e1v59eef0"
})(_ref9 => {
  let {
    theme,
    color
  } = _ref9;
  return {
    width: '20px',
    height: '20px',
    backgroundColor: color,
    cursor: 'pointer'
  };
}, "");
export { StyledDeleteArea, StyledInputArea, StyledInputField, StyledLine, StyledPalette, StyledPickColorArea, StyledPickColorAreaTitle, StyledPopover, StyledSingleColor };